<script>
	// import { inject } from '@vercel/analytics'
	// inject();

	import Splash from "./Splash.svelte"
	import Nav from "./Nav.svelte"
	import About from "./About.svelte"
	import Skills from "./Skills.svelte"
	import Footer from "./Footer.svelte";
	import Experience from "./Experience.svelte";
	import Projects from "./Projects.svelte";
	import Journal from "./Journal.svelte";
	import Contact from "./Contact.svelte";
	import Menu from "./Menu.svelte";

	let displayMenu = false;
	function toggleMenu(e) {
		e.stopPropagation();
		displayMenu = !displayMenu;
	}
	function openMenu(e) {
		e.stopPropagation();
		displayMenu = true;
	}
	function closeMenu(e) {
		e.stopPropagation();
		displayMenu = false;
	}
	function onClose() {
		// TODO instead bind menu close to mouse away
		displayMenu = false;
	}
</script>

<div>
	<Menu visible={displayMenu} onCloseCallback={onClose}/>
	<main class:displayMenu on:click={onClose}>
		<Splash />
		<Nav onOpenMenu={openMenu} onCloseMenu={closeMenu} displayMenu={displayMenu} />
		<div class="wrapper">
			<div class="container">
				<About />
				<Skills />
				<Experience />
				<!--
				<Projects />
				<Journal />
				-->
				<Contact />
			</div>
		</div>
		<Footer />
	</main>
</div>


<style>
	main {
		height: 100%;
		width: 100%;
		transition-property: margin-left, margin-right;
		transition-duration: 0.6s;
	}
</style>